import { IApplicationState } from '../../types/redux';
import { isFsk } from '../../utils';
import { getDeveloper } from '../developer';

export function checkFsk(state: IApplicationState) {
  const developer = getDeveloper(state);

  return isFsk(developer.specProjectType);
}
